import { AppDataModels, DataModelState } from '../models/DataModelState'
import { DataModelsActions, SET_DATA_MODELS } from './actions/data-models.actions'

const normalizeDataModels = (data: Partial<AppDataModels>): Partial<AppDataModels> => {
  if (!Object.keys(data).length) {
    return data
  }

  return {
    ...data,
    countryCodes: data.countryCodes ?? data.phoneCountryCodes
  }
}

export function setDataModels(data: Partial<AppDataModels>): DataModelsActions {
  return {
    type: SET_DATA_MODELS,
    payload: normalizeDataModels(data)
  }
}

export function getDataModels(store: { dataModel: DataModelState }): Partial<AppDataModels> {
  return normalizeDataModels(store.dataModel.data)
}

const initialState: DataModelState = {
  data: {}
}

export default function dataModelsReducer(
  state = initialState,
  action: DataModelsActions
): DataModelState {
  switch (action.type) {
    case SET_DATA_MODELS:
      return {
        ...state,
        data: normalizeDataModels(action.payload)
      }

    default:
      return state
  }
}
